import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class DBInventory {
  // DB商品入库列表
  postDBStock(currentPage, start, end, orderNumber, warehouseId) {
    const url = `/api/stock/search?currentPage=${currentPage}&start=${start}&end=${end}&orderNumber=${orderNumber}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 新建商品入库
  postDBInStock(data) {
    const url = '/api/stock/add'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改可售库存
  postDBSaleNum(id, items) {
    const url = '/api/goods/modify/sale/num'
    let data = {
      id,
      items
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改商品库存
  postDBStockNum(data) {
    const url = '/api/goods/modify/sale/num'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取入库单详情
  getDBDetailStock(id) {
    const url = '/api/stock/search/info?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取分页仓库信息
  getDBWarehouse(currentPage) {
    const url = '/api/warehouse/page?currentPage=' + currentPage
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取服务范围信息
  getDBService(warehouseId) {
    const url = `/api/warehouse/scope/list?warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取所有仓库信息
  getDBAllWarehouse() {
    const url = '/api/warehouse/list'
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加仓库
  postDBAddWarehouse(name, province, city, regions, address, erpWarehouseId) {
    const url = '/api/warehouse/add'
    let data = {
      name,
      province,
      city,
      regions,
      address,
      erpWarehouseId
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改仓库
  postDBUpdateWarehouse(id, name, province, city, regions, address, erpWarehouseId) {
    const url = '/api/warehouse/modify'
    let data = {
      id,
      name,
      province,
      city,
      regions,
      address,
      erpWarehouseId
    }
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //DB仓库管理添加服务范围
  postDBAddWareHouseScope(data) {
    const url = '/api/warehouse/scope/add'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除仓库
  getDBDeleteWarehouse(id) {
    const url = '/api/warehouse/delete?id=' + id
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB出库单列表
  getDBOutStock(currentPage, outStockCode, startTime, endTime, warehouseId) {
    const url = `/api/db/stock/out/list?currentPage=${currentPage}&outStockCode=${outStockCode}&startTime=${startTime}&endTime=${endTime}&warehouseId=${warehouseId}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加出库
  postDBAddOutStock(data) {
    const url = `/api/db/stock/out/add`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB出库详情
  getDBOutStockDetail(id) {
    const url = `/api/db/stock/out/detail?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // DB出库根据仓库获取对应的商品
  getDBOutStockGoodsList(options) {
    let url = `/api/goods/request/search/storage/out?`
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 可售库存开关详情
  getDBSaleInventoryDetail() {
    const url = `/api/warehouse/saleNumEqualNum`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 可售库存开关更新操作
  getDBSaleInventoryUpload() {
    const url = `/api/warehouse/update/saleNumEqualNum`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBInventory
